<template>
  <div class="cjpm-page">
    <div>
      <van-nav-bar
        title="成绩排名"
        left-text="返回"
        left-arrow
        @click-left="onTopClickLeft"
      >
        <a
          :href="
            routeValue === null ||
            routeValue === undefined ||
            routeValue.length === 0
              ? 'https://www.ptty.com.cn/wap/#/'
              : 'https://www.ptty.com.cn/wap/#/' + routeValue
          "
          slot="right"
          style="font-size:20px;"
        >
          <van-icon style="font-size:20px;" name="wap-home" />
        </a>
      </van-nav-bar>
    </div>
    <van-pull-refresh
      v-model="isLoading"
      @refresh="onRefresh"
      :disabled="!isAtTop"
    >
      <div style="margin-top:60px"></div>

      <!-- 成绩排名卡片 -->
      <div class="cjpm-container">
        <!-- 搜索框 -->
        <div class="search-bar" v-if="resultList.length > 0">
          <van-search
            v-model="searchKeyword"
            placeholder="搜索选手姓名或队伍"
            show-action
            @search="onSearch"
          >
            <template #action>
              <div @click="onSearch" class="search-button">搜索</div>
            </template>
          </van-search>
        </div>

        <div class="cjpm-card" v-if="resultList.length > 0">
          <!-- 项目标题 -->
          <div class="cjpm-header">
            <div class="header-icon">🏆</div>
            <div class="header-content">
              <h4 class="project-title">{{ resultList[0].XMQC }}</h4>
              <p class="project-subtitle">{{ resultList[0].XMJC }}</p>
            </div>
          </div>

          <!-- 成绩排名表格 -->
          <div class="cjpm-table-wrapper">
            <table class="cjpm-table">
              <thead>
                <tr>
                  <th v-if="sszl === 'XH'" class="group-col">组号</th>
                  <th class="rank-col">名次</th>
                  <th class="team-col">队伍全称</th>
                  <th class="player-col">人/队名</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(item, index) in resultList"
                  :key="index"
                  :ref="'row-' + index"
                  :class="[
                    'table-row',
                    { 'quit-row': item.ISPF === '1' || item.ISPF === '2' },
                    { 'highlight-row': highlightedRow === index }
                  ]"
                >
                  <td v-if="sszl === 'XH'" class="group-cell">
                    <div>{{ item.ZHORLC }}组</div>
                  </td>
                  <td class="rank-cell">
                    <div class="rank-badge" :class="getRankClass(item.MCDATA)">
                      <span class="rank-icon">{{
                        getRankIcon(item.MCDATA)
                      }}</span>
                      <span class="rank-number">{{ item.MCDATA }}</span>
                    </div>
                  </td>
                  <td class="team-cell">{{ item.DWQC1 }}</td>
                  <td class="player-cell">
                    <span class="player-name">{{ item.RYXM1 }}</span>
                    <span v-if="item.RYXM2.length > 0" class="player-name">
                      / {{ item.RYXM2 }}
                    </span>
                    <span v-if="item.RYXM_FIN.length > 0" class="player-name">
                      / {{ item.RYXM_FIN }}
                    </span>
                    <span
                      v-if="item.ISPF === '1' || item.ISPF === '2'"
                      class="quit-tag"
                    >
                      (弃)
                    </span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </van-pull-refresh>
    <loading-com />
    <div style="height:100px;width:15px;"></div>
  </div>
</template>

<script>
import LoadingCom from "../commonCom/LoadingCom.vue";
export default {
  name: "CjpmIndex",
  components: { LoadingCom },
  data() {
    return {
      isLoading: false,
      utilPost: "",
      ssid: "",
      sszl: "",
      xmid: "",
      resultList: [],
      routeValue: "",
      isAtTop: true, // 是否在顶部
      // 搜索相关
      searchKeyword: "", // 搜索关键词
      highlightedRow: null // 高亮的行索引
    };
  },
  created() {
    this.utilPost = this.$util.handler;
    this.ssid = this.$route.query.ssid;
    this.sszl = this.$route.query.sszl;
    this.xmid = this.$route.query.xmid;
  },
  mounted() {
    var routeValue = localStorage.getItem("routeValue");
    this.routeValue = routeValue;
    var openIdEn = localStorage.getItem("openIdEn");
    if (openIdEn === undefined || openIdEn === null || openIdEn.length === 0) {
      this.utilPost.getOpenId(function(openId) {});
    }
    this.mainLoadData();
    // 监听滚动事件
    window.addEventListener("scroll", this.handleScroll);
  },
  beforeDestroy() {
    // 移除滚动监听
    window.removeEventListener("scroll", this.handleScroll);
  },
  methods: {
    // 处理滚动事件
    handleScroll() {
      // 判断是否在顶部（允许10px的误差）
      this.isAtTop =
        window.pageYOffset <= 10 || document.documentElement.scrollTop <= 10;
    },
    // 获取名次样式类
    getRankClass(rank) {
      const rankNum = parseInt(rank);
      if (rankNum === 1) return "rank-gold";
      if (rankNum === 2) return "rank-silver";
      if (rankNum === 3) return "rank-bronze";
      return "rank-normal";
    },
    // 获取名次图标
    getRankIcon(rank) {
      // 如果名次包含"-"，不显示奖牌
      if (rank && rank.toString().includes("-")) {
        return "";
      }
      if (this.sszl === "XH") {
        return "";
      }
      const rankNum = parseInt(rank);
      if (rankNum === 1) return "🥇";
      if (rankNum === 2) return "🥈";
      if (rankNum === 3) return "🥉";
      return "🏅";
    },
    // 搜索功能
    onSearch() {
      if (!this.searchKeyword || this.searchKeyword.trim() === "") {
        this.$toast("请输入搜索关键词");
        return;
      }

      const keyword = this.searchKeyword.trim().toLowerCase();
      let found = false;

      // 遍历所有数据查找匹配项
      for (let index = 0; index < this.resultList.length; index++) {
        const item = this.resultList[index];
        const ryxm1 = (item.RYXM1 || "").toLowerCase();
        const ryxm2 = (item.RYXM2 || "").toLowerCase();
        const dwqc1 = (item.DWQC1 || "").toLowerCase();

        // 检查是否匹配选手姓名或队伍名称
        if (
          ryxm1.includes(keyword) ||
          ryxm2.includes(keyword) ||
          dwqc1.includes(keyword)
        ) {
          found = true;
          // 设置高亮
          this.highlightedRow = index;

          // 滚动到目标位置
          this.$nextTick(() => {
            const refName = "row-" + index;
            const targetRow = this.$refs[refName];
            if (targetRow && targetRow[0]) {
              targetRow[0].scrollIntoView({
                behavior: "smooth",
                block: "center"
              });

              // 3秒后取消高亮
              setTimeout(() => {
                this.highlightedRow = null;
              }, 3000);
            }
          });
          return;
        }
      }

      // 未找到匹配项
      if (!found) {
        this.$toast("未找到匹配的选手或队伍");
        this.highlightedRow = null;
      }
    },
    onRefresh() {
      this.mainLoadData();
    },
    onTopClickLeft() {
      this.$router.go(-1);
    },
    mainLoadData() {
      var busData = {
        XMID: this.xmid,
        SSZL: this.sszl
      };
      var paramData = {
        headerData: {
          ssid: this.ssid,
          op: "wapGL", //反射名称
          methodName: "getCjpmData" //对应的方法名
        },
        busData: busData //参数内容
      };
      this.utilPost.paramData = paramData;
      //alert(JSON.stringify(paramData));
      this.utilPost.sendPost().then(data => {
        //alert(JSON.stringify(data));
        this.isLoading = false;
        if (!data.isSuccess) {
          alert(data.msg);
          return;
        }
        this.resultList = data.content;
      });
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.cjpm-page {
  min-height: 100vh;
  background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
}

/deep/.van-nav-bar {
  position: fixed;
  top: 0px;
  width: 100%;
  z-index: 100;
}

.xhsTableClass {
  background: #fff;
  width: 100%;
  border-collapse: collapse;
}
.xhsTableClass td {
  width: 100px;
  text-align: center;
  border: 1px solid #ddd;
  padding: 10px;
  font-size: 13px;
}

/* 成绩排名样式 */
.cjpm-container {
  padding: 0 12px 12px;
}

/* 搜索栏样式 */
.search-bar {
  margin-bottom: 12px;
  background: #fff;
  border-radius: 16px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);
  overflow: hidden;

  /deep/ .van-search {
    padding: 0px;
  }

  /deep/ .van-search__content {
    background: #fff;
    border-radius: 12px;
    padding-left: 12px;
  }

  /deep/ .van-field__left-icon {
    color: #185f9b;
  }

  /deep/ .van-cell {
    padding: 8px 0;
  }
}

.search-button {
  padding: 0px 16px;
  background: linear-gradient(135deg, #185f9b 0%, #1a6ba8 100%);
  color: #fff;
  border-radius: 12px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 2px 8px rgba(24, 95, 155, 0.3);

  &:active {
    transform: scale(0.95);
    box-shadow: 0 1px 4px rgba(24, 95, 155, 0.3);
  }
}

.cjpm-card {
  background: #fff;
  border-radius: 16px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  overflow: hidden;
  border: 1px solid rgba(24, 95, 155, 0.1);
}

/* 项目标题区域 */
.cjpm-header {
  display: flex;
  align-items: center;
  padding: 20px;
  background: linear-gradient(135deg, #185f9b 0%, #1a6ba8 100%);
  color: #fff;
  gap: 16px;
}

.header-icon {
  font-size: 32px;
  filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.2));
}

.header-content {
  flex: 1;
}

.project-title {
  margin: 0 0 6px 0;
  font-size: 18px;
  font-weight: 600;
  color: #fff;
  line-height: 1.3;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.project-subtitle {
  margin: 0;
  font-size: 14px;
  color: rgba(255, 255, 255, 0.9);
  line-height: 1.4;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

/* 表格容器 */
.cjpm-table-wrapper {
  overflow-x: visible;
  -webkit-overflow-scrolling: touch;
}

/* 表格样式 */
.cjpm-table {
  width: 100%;
  border-collapse: collapse;
  background: #fff;
  table-layout: fixed;
}

.cjpm-table thead {
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
}

.cjpm-table thead tr {
  border-bottom: 2px solid #185f9b;
}

.cjpm-table th {
  padding: 14px 8px;
  text-align: center;
  font-size: 14px;
  font-weight: 600;
  color: #333;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  word-wrap: break-word;
}

.group-col {
  width: 70px;
}

.rank-col {
  width: 80px;
}

.team-col {
  width: 33%;
}

.player-col {
  width: auto;
}

/* 表格行 */
.table-row {
  border-bottom: 1px solid #f0f0f0;
  transition: all 0.3s ease;
}

.table-row:hover {
  background: linear-gradient(135deg, #f8f9ff 0%, #e8f2ff 100%);
  transform: translateX(2px);
}

.table-row:last-child {
  border-bottom: none;
}

/* 高亮行 */
.highlight-row {
  background: linear-gradient(135deg, #fff3cd 0%, #ffe8a1 100%) !important;
  animation: highlightPulse 1.5s ease-in-out;
  box-shadow: 0 0 0 2px #ffc107;
}

@keyframes highlightPulse {
  0%,
  100% {
    opacity: 1;
  }
  50% {
    opacity: 0.8;
  }
}

/* 弃权行样式 */
.quit-row {
  background: rgba(255, 0, 0, 0.03);
  opacity: 0.7;
}

.quit-row:hover {
  background: rgba(255, 0, 0, 0.06);
}

/* 表格单元格 */
.cjpm-table td {
  padding: 12px 8px;
  text-align: center;
  font-size: 14px;
  color: #333;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  word-wrap: break-word;
  word-break: break-word;
  white-space: normal;
}

/* 组号徽章 */
.group-cell {
  padding: 10px 8px;
}

.group-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 50px;
  height: 50px;
  padding: 0 8px;
  background: linear-gradient(135deg, #52c41a 0%, #73d13d 100%);
  color: #fff;
  font-size: 14px;
  font-weight: 700;
  border-radius: 50%;
  box-shadow: 0 2px 8px rgba(82, 196, 26, 0.3);
  transition: all 0.3s ease;
}

.table-row:hover .group-badge {
  transform: scale(1.05);
  box-shadow: 0 4px 12px rgba(82, 196, 26, 0.4);
}

/* 名次徽章 */
.rank-cell {
  padding: 10px 12px;
}

.rank-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  min-width: 50px;
  height: 40px;
  border-radius: 10px;
  font-size: 16px;
  font-weight: 700;
  padding: 0 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
}

.rank-icon {
  font-size: 20px;
  line-height: 1;
  filter: drop-shadow(0 1px 2px rgba(0, 0, 0, 0.2));
}

.rank-number {
  font-size: 16px;
  font-weight: 700;
  line-height: 1;
}

.rank-badge.rank-gold {
  background: linear-gradient(135deg, #ffd700 0%, #ffed4a 100%);
  color: #8b5a00;
  box-shadow: 0 4px 12px rgba(255, 215, 0, 0.4);
}

.rank-badge.rank-silver {
  background: linear-gradient(135deg, #c0c0c0 0%, #e8e8e8 100%);
  color: #666;
  box-shadow: 0 4px 12px rgba(192, 192, 192, 0.4);
}

.rank-badge.rank-bronze {
  background: linear-gradient(135deg, #cd7f32 0%, #e6a157 100%);
  color: #fff;
  box-shadow: 0 4px 12px rgba(205, 127, 50, 0.4);
}

.rank-badge.rank-normal {
  background: linear-gradient(135deg, #185f9b 0%, #1a6ba8 100%);
  color: #fff;
}

.table-row:hover .rank-badge {
  transform: scale(1.05);
}

/* 队伍单元格 */
.team-cell {
  text-align: left;
  font-weight: 500;
  color: #333;
  padding-left: 12px !important;
  word-wrap: break-word;
  word-break: break-word;
  white-space: normal;
  line-height: 1.5;
}

/* 球员单元格 */
.player-cell {
  text-align: left;
  padding-left: 12px !important;
  word-wrap: break-word;
  word-break: break-word;
  white-space: normal;
  line-height: 1.5;
}

.player-name {
  color: #333;
  font-weight: 500;
}

.quit-tag {
  display: inline-block;
  margin-left: 6px;
  padding: 2px 8px;
  background: #ff4d4f;
  color: #fff;
  font-size: 12px;
  border-radius: 4px;
  font-weight: 600;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .cjpm-header {
    padding: 16px;
    gap: 12px;
  }

  .header-icon {
    font-size: 28px;
  }

  .project-title {
    font-size: 16px;
  }

  .project-subtitle {
    font-size: 13px;
  }

  .cjpm-table th,
  .cjpm-table td {
    padding: 10px 6px;
    font-size: 13px;
  }

  .team-cell,
  .player-cell {
    padding-left: 8px !important;
  }

  .group-badge {
    min-width: 46px;
    height: 46px;
    font-size: 13px;
  }

  .rank-badge {
    min-width: 46px;
    height: 36px;
    font-size: 14px;
    padding: 0 10px;
    gap: 4px;
  }

  .rank-icon {
    font-size: 18px;
  }

  .rank-number {
    font-size: 14px;
  }

  .group-col {
    width: 65px;
  }

  .rank-col {
    width: 75px;
  }

  .team-col {
    width: 30%;
  }
}

@media (max-width: 480px) {
  .cjpm-container {
    padding: 0 8px 8px;
  }

  .cjpm-header {
    padding: 14px;
    gap: 10px;
  }

  .header-icon {
    font-size: 24px;
  }

  .project-title {
    font-size: 15px;
  }

  .project-subtitle {
    font-size: 12px;
  }

  .cjpm-table th,
  .cjpm-table td {
    padding: 8px 4px;
    font-size: 12px;
  }

  .team-cell,
  .player-cell {
    padding-left: 6px !important;
    font-size: 12px;
  }

  .group-badge {
    width: 36px;
    height: 36px;
    font-size: 13px;
  }

  .rank-badge {
    min-width: 42px;
    height: 32px;
    font-size: 13px;
    padding: 0 8px;
    gap: 3px;
  }

  .rank-icon {
    font-size: 16px;
  }

  .rank-number {
    font-size: 13px;
  }

  .group-col {
    width: 50px;
  }

  .rank-col {
    width: 65px;
  }

  .team-col {
    width: 30%;
  }

  .quit-tag {
    font-size: 11px;
    padding: 1px 6px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/CjpmIndex/CjpmIndex.vue